<template>
  <a-layout>
    <receipt-print-order ref="receiptPrintOrder" @selectRow="selectRow" @reset="reset" />
    <receipt-print-detail ref="receiptPrintODetail" />
  </a-layout>
</template>

<script>
  import ReceiptPrintOrder from '@/views/inbound/receipt_print/ReceiptPrintOrder.vue'
  import ReceiptPrintDetail from '@/views/inbound/receipt_print/ReceiptPrintDetail.vue'

  export default {
    name: 'ReceiptPrint',
    components: { ReceiptPrintDetail, ReceiptPrintOrder },
    methods: {
      selectRow(id) {
        this.$refs.receiptPrintODetail.getData({ 'order.id': id })
      },
      reset() {
        this.$refs.receiptPrintODetail.clear()
      }
    }
  }
</script>